import React, { useEffect, useState } from "react";
import { useSession } from "../utils/Session";
import { useHistory, useLocation } from "react-router";
import { formatCount, objectToPath, pathToObject } from "../utils/Utils";
import { apiCall } from "../utils/Api";
import { Divider, Segmented, Select, Skeleton, Tooltip, Space, Spin, Typography, Layout, Table, Button } from "antd";
import { CloseOutlined, PicLeftOutlined, UnorderedListOutlined } from '@ant-design/icons';
import BrowseFilters from "./BrowseFilters";
import Paginate from "./Paginate";
import ProductSlider from "../content_creator/ProductSlider";
import List from "./List";
import moment from "moment-timezone";
import ListFav from "./ListFav";
import Renderer from "./Renderer";
import ListEdit from "./ListEdit";
import Overlay from "../util_components/Overlay";
import ListQuickPick from "./ListQuickPick";

export default function MyLists() {

    const [session, setSession] = useSession();
    const [view, setView] = useState("list");
    const path = "/my-lists";
    const [loading, setLoading] = useState(false);
    const history = useHistory();
    const location = useLocation();
    const init = pathToObject(location.pathname);
    const [filters, setFilters] = useState(init);
    const [f, setF] = useState([]);
    const [results, setResults] = useState({ rows: [] });
    const [expanded, setExpanded] = useState([]);
    const [expandedTitle, setExpandedTitle] = useState("");

    const [pagination, setPagination] = useState(() => {
        const offset = init?.o ?? 0;
        const limit = init?.l ?? 26;
        return {
            current: Math.floor(offset / limit) + 1,
            offset,
            pagesize: limit
        };
    });


    const count = (results.row_count < results.max_offset) ? results.row_count : results.max_offset;

    const fetchCatalogues = () => {

        setLoading(true);
        let _obj = pathToObject(location.pathname);

        apiCall("titlelist/getMyLists", _obj, (_s, _r) => {
            if (_s) {
                setResults(_r);
                setFilters(_obj);
                setF(_r?.filter_info ?? []);

                const offset = _obj?.o ?? 0;
                const limit = _obj?.l ?? 26;

                setPagination({
                    current: Math.floor(offset / limit) + 1,
                    offset,
                    pagesize: limit
                })

            }
            setLoading(false);
        })
    }
    useEffect(fetchCatalogues, [location.pathname]);

    const drawCatalogues = () => {
        return results.rows.map(item => {
            return (<List results={results} setResults={setResults} type="list" data={item} />)
        });
    }


    const drawChildTable = (_record) => {
        return (
            <>
                <div className="hideHover" style={{ "marginTop": "-7px", "marginLeft": "-8px", "marginRight": "-8px", "maxWidth": "1210px" }}>
                    <div style={{ "padding": "0 0px" }}>
                        <div style={{ "marginTop": "0px", "borderTop": "none", "backgroundColor": "#f1f1f1" }} className="closebar">
                            <Button style={{ "float": "right" }} onClick={() => setExpanded([])} size="small" type="text" icon={<small><CloseOutlined style={{ "fontSize": "10px", "color": "#111" }} /></small>} />
                            <br clear="both" />
                        </div>
                    </div>
                    <div style={{ "padding": "0px 8px", "backgroundColor": "#fff" }}>
                        <Renderer record_key={expanded} >
                            {(expanded && <List type="list" divider={false} is_catalogue={true} getLists={() => { }} setResults={setResults} results={results} data={_record} />)}
                        </Renderer>
                    </div>
                </div>
            </>
        )
    }


    const expandCell = (_data) => {
        if (!expanded.includes(_data.list_id)) {
            setExpanded([_data.list_id]);
        } else {
            setExpanded([]);
        }
    }

    const drawCataloguesList = () => {

        const columns = [

            {
                title: <small>List name</small>, dataIndex: 'name', key: 'name', render: (e, f) => {
                    return (e) ? <a onClick={() => expandCell(f)}>{e}</a> : "";
                }
            },
            {
                title: <small>Titles</small>, dataIndex: 'isbns_count', key: 'isbns_count'
            },
            {
                title: <small>Date created</small>, dataIndex: 'date_created', key: 'date_created', render: (e, f) => {

                    if (!e) { return <></> }
                    return (
                        <>
                            <div><nobr>{moment(e * 1000).format("MMMDD-YY")}</nobr></div><div style={{ "color": "#999" }}>
                                {/* <em>{f.views} views</em> */}
                            </div>
                        </>
                    )
                }
            },
            {
                title: <small>Last updated</small>, dataIndex: 'date_updated', key: 'date_updated', render: (e, f) => {

                    if (!e) { return <></> }
                    return (
                        <>
                            <div><nobr>{moment(e * 1000).format("MMMDD-YY")}</nobr></div><div style={{ "color": "#999" }}>
                                {/* <em>{f.views} views</em> */}
                            </div>
                        </>
                    )
                }
            },
            {
                title: <small>Owner</small>, dataIndex: 'owner_name', key: 'owner_name', render: (e, f) => {
                    return <>{e}</>
                }
            },

          


        ]


        if(session?.has_bm_data_full || session?.has_bm_data_lite){
            columns.push(  {
                title: <small>Quick pick</small>, dataIndex: 'qp', key: 'qp', render: (e, f) => {

                    return <ListQuickPick list={f} list_id={f.list_id} />
                }
            },)
        }


        return (
            <div >
                <div style={{ minWidth: 'auto' }}>
                    <Table
                        rowKey="list_id"
                        size="small"
                        columns={columns}
                        className={"fullTable"}
                        dataSource={results.rows}
                        pagination={false}
                        expandable
                        expandedRowKeys={expanded}
                        expandIconColumnIndex={-1}
                        onExpand={(e) => { return false; }}
                        expandIcon={() => { return (<></>) }}
                        expandedRowRender={((record) => drawChildTable(record))}
                    />
                </div>
            </div>
        );
    }



    return (
        <div className="container">
            <div className="float-flex">
                <Space align="center"><Typography.Title style={{ "marginBottom": "6px" }} level={4}>My Lists</Typography.Title><span style={{ "fontSize": "14px", "opacity": "0.8" }}>({results?.row_count ?? 0}) lists</span></Space>
                <div>
                    <Segmented onChange={(e) => setView(e)} value={view} size="small" options={[
                        {
                            value: 'details',
                            icon:
                                <Tooltip title="Detailed View">
                                    <PicLeftOutlined style={{ "fontSize": "13px" }} />
                                </Tooltip>,
                        },
                        {
                            value: 'list',
                            icon:
                                <Tooltip title="Brief View">
                                    <UnorderedListOutlined style={{ "fontSize": "13px" }} />
                                </Tooltip>,
                        }
                    ]}
                    />
                </div>
            </div>
            <Spin spinning={loading}>
                <div>
                    <div>
                        <BrowseFilters loading={loading} create={<>
                            <Overlay width={700} component={<ListEdit create callback={fetchCatalogues} />}>
                                <Button size="large" type="primary">Create List</Button>
                            </Overlay>
                        </>} sort={
                            <Space>
                                <small>Sort:</small>
                                <Select
                                    value={filters.v}
                                    onChange={(value) => {
                                        history.push({ pathname: path + objectToPath({ ...filters, "v": value, "o": 0 }) });
                                    }}
                                    style={{ width: 150 }}
                                    className="asa-select"
                                    placeholder="What's in store"
                                >
                                    <Select.Option value="">Last updated</Select.Option>
                                    <Select.Option value="date_posted">Date Posted</Select.Option>
                                    <Select.Option value="name">Alphabetical</Select.Option>
                                </Select>
                            </Space>

                        } path={path} searchFilters={filters} setSearchFilters={setFilters} setFilters={setF} filters={f} />
                    </div>
                    <div className="shim" />
                    <Divider style={{ "margin": "0px 0px" }} />
                    <Layout>
                        <Layout.Content style={{ "backgroundColor": "#fff" }}>
                            <div className="shim" /><div className="shim" />
                            <Paginate key={"paginate-1"} count={count} paginate={pagination} setPaginate={(_p) => {
                                setPagination(_p)
                                history.push({ pathname: path + objectToPath({ ...filters, "l": _p.pagesize, "o": _p.offset }) });
                            }} />
                            <Divider key={"divider-1"} dashed style={{ "margin": "10px 0px", "marginRight": "0px", "width": "auto", "minWidth": "auto" }} />

                            {(view === "details" && <div>{drawCatalogues()}</div>)}

                            {(view === "list" && <div>{drawCataloguesList()}</div>)}


                            <Paginate key={"paginate-2"} count={count} paginate={pagination} setPaginate={(_p) => {
                                setPagination(_p)
                                history.push({ pathname: path + objectToPath({ ...filters, "l": _p.pagesize, "o": _p.offset }) });
                            }} />
                        </Layout.Content>
                    </Layout>
                </div>
            </Spin>
        </div>
    )
}